<template>
<div class="qc-schedule-list-print" v-loadding="loading">
  <el-table :data="listData" border style="width: 100%">
    <el-table-column prop="confirmDateWeek" label="星期" width="180">
      <template slot-scope="scope"
        >星期{{ scope.row.confirmDateWeek }}</template
      >
    </el-table-column>
    <el-table-column prop="confirmNewDate" label="日期" width="180">
    </el-table-column>
    <el-table-column
      v-for="item in headerList"
      :key="item.prop"
      :prop="item.prop"
      :label="item.prop"
    >
    <template slot-scope="scope">
      <div v-for="_item in scope.row[item.prop]" :key="_item">
        <div class="cell-wrap">{{_item}}</div>
      </div>
    </template>
    </el-table-column>
  </el-table>
</div>
</template>

<script>
import {createIframePrint} from 'src/common/print';
export default {
  name: "qc-schedule",
  data() {
    return {
      listData: [],
      headerList: [],
      loading: false
    };
  },
  methods: {
    init() {
      let { brandCode, endTime, factory, matShowFlag, qcGroup, startTime } =
        this.$route.query;
        this.loading = true
      this.$apis.autoAPi.POST_QCSCHEDULE_CHECK_LIST({
        brandCode,
        endTime,
        factory,
        matShowFlag,
        qcGroup,
        startTime,
      }).done(resp => {
        this.loading = false
        if(resp.code == 0) {
          this.headerList = resp.data.person.map(item => ({prop: item}))
          resp.data.data.forEach(item => {
            this.$utils.forIn(item.personMap, (value, key) => {
              item[key] = value.map(_item => {
                return `${_item.materialCode || ''}(${_item.reserveTypeDesc || ''})/${_item.vendorName || ''}`
              })
            })
          })
          this.listData = resp.data.data
          setTimeout(() => {
            this.handlePrint()
          }, 100);
        } else {
          this.$message.warning('打印错误')
          this.loading = false
        }
      })
    },
    handlePrint() {
      const ele = document.querySelector('.qc-schedule-list-print');
      createIframePrint(ele)
    }
  },
  mounted() {
    this.init();
  },
};
</script>
<style>
.cell-wrap {
  white-space: normal;
  word-wrap: break-word;
}
</style>